// extracted by mini-css-extract-plugin
export var image = "newsletter-gist-picks-module--image--b9379";
export var intro = "newsletter-gist-picks-module--intro--8509f";
export var intro__lifestyle = "newsletter-gist-picks-module--intro__lifestyle--5cbd6";
export var number = "newsletter-gist-picks-module--number--70898";
export var pick__lifestyle = "newsletter-gist-picks-module--pick__lifestyle--65d69";
export var pick__regular = "newsletter-gist-picks-module--pick__regular--306de";
export var spin = "newsletter-gist-picks-module--spin--9a8c7";
export var wrapper = "newsletter-gist-picks-module--wrapper--d7dca";
export var wrapper__lifestyle = "newsletter-gist-picks-module--wrapper__lifestyle--6a39c";